import { tenantParamKey } from '@/composables/route'
import { Permission } from '@/lib/permissions/v1'

export enum AdminTenantsRouteName {
    Index = 'admin.tenants.index',
    Create = 'admin.tenants.create',
    Details = 'admin.tenants.details',
    Edit = 'admin.tenants.edit',
    Emails = 'admin.tenants.templates.emails.edit',
}

export default {
    path: 'tenants',
    component: () => import('@/views/admin/Index.vue'),
    meta: {
        label: 'Tenants',
        auth: true,
        breadcrumb: false,
    },
    children: [
        {
            path: '',
            name: AdminTenantsRouteName.Index,
            component: () => import('@/views/admin/tenant/Index.vue'),
            meta: {
                label: 'Tenants',
                auth: true,
                permission: Permission.TenantViewAny,
            },
        },
        {
            path: 'create',
            name: AdminTenantsRouteName.Create,
            component: () => import('@/views/admin/tenant/Index.vue'),
            meta: {
                label: 'Create Tenant',
                auth: true,
                permission: Permission.TenantCreate,
            },
        },
        {
            path: `:${tenantParamKey}/details`,
            name: AdminTenantsRouteName.Details,
            component: () => import('@/views/admin/tenant/Details.vue'),
            meta: {
                label: 'Tenant Details',
                auth: true,
                permission: Permission.TenantView,
            },
        },
        {
            path: `:${tenantParamKey}/edit`,
            name: AdminTenantsRouteName.Edit,
            component: () => import('@/views/admin/tenant/Index.vue'),
            meta: {
                label: 'Edit Tenant',
                auth: true,
                permission: Permission.TenantUpdate,
            },
        },
        {
            path: `:${tenantParamKey}/templates/emails/edit`,
            name: AdminTenantsRouteName.Emails,
            component: () => import('@/views/admin/tenant/Index.vue'),
            meta: {
                label: 'Edit Email Templates',
                auth: true,
                permission: Permission.TenantUpdate,
            },
        },
    ],
}
